import { alpha, Theme } from '@mui/material/styles';

export default function Alert(theme: Theme) {
  const tone = (main: string) => ({
    backgroundColor: alpha(main, 0.08),
    border: `1px solid ${alpha(main, 0.4)}`,
    color: theme.palette.text.primary,
    '& .MuiAlert-icon': { color: main },
  });

  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: 'none',
          alignItems: 'center',
        },
        standardError: tone(theme.palette.error.main),
        standardWarning: tone(theme.palette.warning.main),
        standardInfo: tone(theme.palette.info.main),
        standardSuccess: tone(theme.palette.success.main),
      },
    },
  };
}
